import React from 'react';
import { connect } from 'react-redux';
import settings from 'settings';
import PropTypes from 'prop-types';
import DurationPicker from 'components/durationPicker/duration-picker';
import ColorPicker from 'components/colorPicker/color-picker';
import {
  Checkbox, Form, Input, Tag
} from 'antd';
import _ from 'lodash';
import ExtendedSelect from 'components/extendedSelect';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import {
  convertToSelect, durationValidator, getKey, getLabel
} from 'library/helpers';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  types: state.api.activityTypes.data.results
});

const mapDispatchToProps = dispatch => ({
  loadTypes(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(REDUCER_KEY.activityTypes.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name, color, duration, active, activity_type, allows_sign_on_windows
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    duration: Form.createFormField({ value: duration }),
    color: Form.createFormField({ value: color }),
    activity_type: Form.createFormField({ value: convertToSelect(activity_type) }),
    active: Form.createFormField({ value: active }),
    allows_sign_on_windows: Form.createFormField({ value: allows_sign_on_windows })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form, loadTypes, types
}) => {
  const { getFieldDecorator } = form;
  const {
    active, color, duration, name, activity_type, allows_sign_on_windows
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Activity name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Type">
        {getFieldDecorator('activity_type', {
          initialValue: activity_type,
          rules: [{
            required: true,
            message: 'Please enter an Activity Type.'
          }]
        })(
          <ExtendedSelect
            placeholder="Select Type"
            dataSource={types}
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={readonly}
            onFocus={loadTypes}
            onSearch={loadTypes}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Duration">
        {
          getFieldDecorator('duration', {
            initialValue: duration,
            rules: [
              {
                required: true,
                message: 'Please enter the Duration.'
              },
              {
                message: 'Duration must not be less than 15 minutes',
                validator: durationValidator
              }
            ]
          })(
            <DurationPicker disabled={readonly} />
          )
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Colour">
        {!readonly && getFieldDecorator('color', {
          initialValue: color,
          rules: [{
            required: true,
            message: 'Please enter a Colour.'
          }]
        })(<ColorPicker />)}
        {readonly && (
          <Tag color={color}>
            {color}
          </Tag>
        )}
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout} extra="Assignments of this activity can have available sign-on windows.">
        {
          getFieldDecorator('allows_sign_on_windows', {
            initialValue: allows_sign_on_windows,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Allow sign-on windows
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  types: PropTypes.array,
  loadTypes: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  types: [],
  loadTypes() {
  }
};

const ConnectedFormInput = connect(mapStateToProps, mapDispatchToProps)(FormInput);

const ActivityFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default ActivityFormInput;
